<form (ngSubmit)="submit()" [formGroup]="editForm" class="body">
    <div class="header" fxLayoutAlign="space-between center">
        <div>Benutzer</div>
        <div class="close-button" (click)="close()">
            <i class="ju ju-close"></i>
        </div>
    </div>
    <div class="body-t" fxLayout="column">
        <div>
            <div fxLayout="column" class="box">
                <label class="label" for="currentPassword">Aktuelles Passwort</label>
                <input id="currentPassword" formControlName="currentPassword" type="password"
                       [class]="currentPasswordInvalid() ? 'invalid' : ''" placeholder="Passwort eingeben"/>
                <span *ngIf="currentPasswordInvalid()"></span>
            </div>
        </div>
        <div>
            <div class="input-group">
                <div class="label">Neues Passwort</div>
                <input type="password" formControlName="newPassword"
                       [class]="newPasswordInvalid() ? 'invalid' : ''" placeholder="Passwort eingeben"/>
            </div>
        </div>
        <div>
            <div fxLayout="column" class="box">
                <label class="label" for="newPasswordRepeat">Passwort wiederholen</label>
                <input id="newPasswordRepeat" formControlName="newPasswordRepeat" type="password"
                       [class]="newPasswordInvalid() ? 'invalid' : ''" placeholder="Passwort wiederholen"/>
                <span *ngIf="newPasswordInvalid()"></span>
            </div>
        </div>
        <button type="submit" fxLayoutAlign="center center">Speichern</button>
    </div>
</form>
